module.exports = __webpack_public_path__ + "media/b0.fcf6dcbf.mp3";